<template>
  <div v-if="mvm" class="info">
    <div v-if="dvm">
      <el-row>
        <el-col>
          <h2>機台編號：{{ mvm.AssetNo }}</h2>
          <h3 v-show="mvm.client">客戶名稱： {{ mvm.client && mvm.client.customer_code }} {{ mvm.client && mvm.client.name }}</h3>
          <h3 v-show="mvm.op_locate">機台位置：{{ mvm.op_locate && mvm.op_locate.location_code }} {{ mvm.op_locate && mvm.op_locate.location_name }}</h3>
          <h3>發票是否啟用：{{ mvm.invoice_settings.Invoice ? '啟用' : '不啟用' }}</h3>
          <h3>發票啟用起始時間：{{ mvm.invoice_settings.EnableSince }}</h3>
          <h3>是否列印發票：{{ dvm.setting.printInvoice | printInvoiceFilter }}</h3>
          <h3>是否列印明細：{{ dvm.setting.printReceipt | printDetailFilter }}</h3>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="gates">
          <el-row>
            <el-col :lg="6" :sm="12" :xs="24" v-for="(gate, index) of dvm.gates" :key="index">
              <el-card shadow="hover" class="gate" :class="gate | statusFilter">
                <h2>貨道 {{ gate.GateNo }}</h2>
                <div class="d-flex flex-row">
                  <div v-if="gate.Product.ProductNa" class="m-0 pl-0">
                    <h2 class="bg-light p-1 text-dark rounded m-0 mb-1">
                      {{ gate.Product.ProductNa }}
                    </h2>
                    <el-table :data="[gate]" size="mini" :cell-style="{ fontSize: '1.8rem', textAlign: 'center' }" style="font-size: 1.2rem">
                      <el-table-column width="60" prop="Product.UnitPrice" label="售價" />
                      <el-table-column width="60" prop="Stock" label="庫存" />
                      <el-table-column width="60" prop="Sales" label="銷售" />
                      <el-table-column width="60" prop="Short" label="缺補" />
                    </el-table>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { updateMvm, getMvmModels, deleteMvm, getMvm } from '@/api/mvms';
export default {
  filters: {
    statusFilter(gate) {
      return !gate.Product.ProductNa ? 'none' : gate.Short !== 0 ? 'short' : 'ok';
    },
    printInvoiceFilter(key) {
      const map = {
        true: '列印發票',
        false: '不印發票',
      };
      return key ? map[key] : '不印發票';
    },
    printDetailFilter(key) {
      const map = {
        true: '列印明細',
        false: '不印明細',
      };
      return key ? map[key] : '不印明細';
    },
  },
  props: {
    id: null,
  },
  data() {
    return {
      dvm: null,
      mvm: null,
    };
  },
  async created() {
    try {
      let mvm = await getMvm(this.id);
      if (typeof mvm === 'string') {
        mvm = JSON.parse(mvm);
      }
      let dvm = mvm.dvm;
      if (typeof dvm === 'string') {
        dvm = JSON.parse(dvm);
        mvm.dvm = dvm;
      }
      // console.log(`[views/mvms/components/info.vue] mvm: ${JSON.stringify(mvm)}`);
      // console.log(`[views/mvms/components/info.vue] dvm: ${JSON.stringify(dvm)}`);
      dvm.gates = dvm.gates.gates ? dvm.gates.gates : dvm.gates;
      this.dvm = dvm;
      this.mvm = mvm;
    } catch (error) {
      console.error(`created error: ${error}`);
    }
  },
};
</script>
<style scoped>
.info {
  overflow: scroll;
}

.gates {
  overflow: scroll;
}

.gate {
  color: white;
}

.m0 {
  margin: 0;
}

.none {
  background-color: rgba(164, 164, 164, 0.86);
}

.short {
  background-color: rgba(255, 149, 0, 0.86);
}

.ok {
  background-color: rgb(18, 152, 0);
}

.my-header {
  padding: 0px;
}

th {
  font-size: 2rem;
}
</style>
